import { LegacyProfileLink, ProfileLink } from '@/payload-types'
import ReadMoreSnippetComponent from './read-more-snippet'
import Image from 'next/image'
import RenderPublicDetails from '../public-profile-card/profileDetails'
import { createProfileDetails } from '@/lib/profileFunction'
import SnippetComponent from './snippet'
import Link from 'next/link'
interface IProps {
  profileLink?: ProfileLink | LegacyProfileLink
}

export function LegacyProfileSnippetComponent({ profileLink }: IProps) {
  if (
    profileLink?.blockType === 'legacyprofilelink' &&
    typeof profileLink.legacyProfileLink === 'object'
  ) {
    const profession = profileLink.legacyProfileLink?.professions?.filter(
      (item) => item.profession === 'Professor',
    )
    const arrayOfDetails = createProfileDetails(profileLink.legacyProfileLink)
    return (
      <SnippetComponent text={profileLink?.textToDisplay}>
        <span className="block relative text-sm bg-black min-h-9 w-64 p-2 text-white rounded-t-lg right-[1px]">
          <span className="block font-semibold	">
            {profileLink.legacyProfileLink?.fullName
              ? profileLink.legacyProfileLink?.fullName
              : 'Error Name'}
          </span>
        </span>

        <span className="block px-3 py-2">
          <span className="flex flex-row">
            <span className="w-[87px] h-[87px] rounded-full border ">
              <Image
                className={`h-full w-full rounded-full object-cover`}
                src={`${
                  typeof profileLink.legacyProfileLink?.profileImage === 'object'
                    ? profileLink.legacyProfileLink?.profileImage
                    : profileLink.legacyProfileLink?.profileImage
                }`}
                width={600}
                height={600}
                alt={''}
              />
            </span>
            <span className="ml-[10px] text-sm w-[144px] h-[85px] leading-[18px]">
              <RenderPublicDetails arrayOfData={arrayOfDetails} showMore={false} allItems={false} />
            </span>
          </span>

          <span className="font-normal text-sm !m-0">
            <span className="!line-clamp-[10] richTextContentAccordion">
              {profileLink.legacyProfileLink?.description}
            </span>
            <Link
              href={`/${profession ? 'professor' : 'individual'}/${
                profileLink.legacyProfileLink?.slug
              }`}
              className="font-bold text-sm !text-black flex flex-row items-center outline-0"
              target="_blank"
            >
              <ReadMoreSnippetComponent />
            </Link>
          </span>
        </span>
      </SnippetComponent>
    )
  } else {
    ;<></>
  }
}
